var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(!_vm.isCustom)?_c('System404',_vm._g(_vm._b({},'System404',_vm.$attrs,false),_vm.$listeners)):_vm._e(),(_vm.isCustom)?_c('Custom404',_vm._g(_vm._b({attrs:{"page-content":_vm.pageContent}},'Custom404',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }